import { useEffect } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useWallet } from '../contexts/walletContext'
import {
  getWalletProvider,
  walletConnectors,
  walletSwitchEthChain
} from '../services/wallet'
import { getAddChainParameters } from '../services/wallet/chains'
import { isMobile } from 'react-device-detect'
import { WALLET_SUPPORTED_CHAIN_IDS } from '../config'

function Connect ({ connector, hooks, targetChainId }) {
  const { setWallet } = useWallet()

  const {
    useIsActivating,
    useError,
    useIsActive,
    useChainId,
    useAccount,
    useProvider,
    useENSName
  } = hooks
  const isActivating = useIsActivating()
  const active = useIsActive()
  const error = useError()
  const chainId = useChainId()
  const provider = useProvider()
  const account = useAccount()
  const ENSName = useENSName(provider)

  const walletProvider = getWalletProvider(connector)
  const walletName = walletProvider?.name || 'Unknown'
  const walletIcon = walletProvider?.icon

  const targetChainParams =
    targetChainId && getAddChainParameters(targetChainId)

  useEffect(() => {
    if (
      active &&
      account &&
      provider &&
      !isActivating &&
      WALLET_SUPPORTED_CHAIN_IDS.includes(chainId)
    ) {
      const wallet = { account, chainId, ENSName }
      setWallet({ connector, hooks, account, provider, wallet })
    }
  }, [active])

  let buttonOnClick = () => {},
    buttonText = '',
    buttonDisabled = false,
    buttonClasses = ''

  if (chainId && !WALLET_SUPPORTED_CHAIN_IDS.includes(chainId)) {
    buttonOnClick = () =>
      provider
        ? walletSwitchEthChain(provider.provider)
        : alert(
            'Your network is not supported. Please switch to the Ethereum Mainnet.'
          )
    buttonText = 'Switch to Ethereum'
    buttonClasses = 'btn-outline-color-danger'
  } else if (error) {
    buttonOnClick = () => connector.activate(targetChainParams)
    buttonText = 'Try Again?'
    buttonClasses = 'btn-outline-color-danger'
  } else if (active) {
    buttonOnClick = connector.deactivate
      ? () => connector.deactivate()
      : undefined
    buttonText = connector.deactivate ? (
      `Disconnect`
    ) : (
      <span>
        <Spinner animation='border' size='sm' /> Initializing{' '}
      </span>
    )
    buttonDisabled = !connector.deactivate
    buttonClasses = 'btn-outline-color-success'
  } else {
    buttonOnClick = isActivating
      ? undefined
      : () => connector.activate(targetChainParams)
    buttonDisabled = isActivating
    buttonText = isActivating ? (
      <Spinner animation='border' size='sm' />
    ) : (
      walletName
    )
  }

  return (
    <Button
      onClick={buttonOnClick}
      disabled={buttonDisabled}
      className={
        'd-flex justify-content-between align-items-center p-3 ' + buttonClasses
      }
      variant='secondary'
    >
      {buttonText}
      <img src={`/imgs/${walletIcon}`} alt='nosense' />
    </Button>
  )
}

const WalletConnectModal = ({ ...props }) => {
  return (
    <Modal
      {...props}
      size='sm'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter' className='h5'>
          Connect wallet
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='d-grid gap-2'>
        {walletConnectors.map(([connector, hooks], i) =>
          // !isMobile ? (
          //   <Connect key={i} connector={connector} hooks={hooks} />
          // ) : (
          //   <div key={i}></div>
          // )
          (i === 0 && !isMobile) ||
          (isMobile && i === 1) ||
          (isMobile && i === 2) ? (
            <Connect key={i} connector={connector} hooks={hooks} />
          ) : (
            <div key={i}></div>
          )
        )}
      </Modal.Body>
    </Modal>
  )
}

export default WalletConnectModal
